import React from "react";
import Spline from "@splinetool/react-spline";
import "../../App.css";

export default function Walk({ onLoad }) {
  return (
    <div>
      <Spline
        style={{ height: "100vh" }}
        scene="https://prod.spline.design/jjTzg29PWUXfY1TT/scene.splinecode"
        onLoad={onLoad}
      />
    </div>
  );
}
